import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/images/logo192.png';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src={logo} alt="Crown Cleaners" className="navbar-logo-img" />
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'} />
        </div>

        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/services" className="nav-link" onClick={closeMenu}>Services & Pricing</Link>
          </li>
          <li className="nav-item">
            <Link to="/locations" className="nav-link" onClick={closeMenu}>Locations</Link>
          </li>
          <li className="nav-item">
            <Link to="/corporate" className="nav-link" onClick={closeMenu}>Corporate Services</Link>
          </li>
          <li className="nav-item">
            <Link to="/delivery" className="nav-link cta-button" onClick={closeMenu}>Free Delivery</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;